// This is an autogenerated file. Do not manually edit.
// Run `node packages/framework/owa-fluent-mobile-brand-icons-svg/updateIcons.js` to update the icons in this package
import * as React from 'react';
import { registerIcons } from '@fluentui/style-utilities';
import { createSvgIcon } from 'owa-fluent-icons-svg/lib/createSvgIcon';

export default 'IcFluentLoopColor';

const IcFluentLoopColor = createSvgIcon({
    Svg: props => (
        <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 2C4.68629 2 2 4.68629 2 8V14H8C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM8 6C9.10457 6 10 6.89543 10 8C10 9.10457 9.10457 10 8 10H6V8C6 6.89543 6.89543 6 8 6Z"
                fill="url(#paint0_linear_148635:964)"
            />
            <path
                d="M8.00039 13.9992H2.00049C2.00049 11.7901 3.79135 9.99921 6.00049 9.99921L7.99893 9.99921C9.1035 9.99921 9.99893 9.10378 9.99893 7.99921L13.9989 7.99921C13.9989 11.3124 11.3134 13.9984 8.00039 13.9992Z"
                fill="url(#paint1_linear_148635:964)"
            />
            <path
                d="M8.00039 13.9992H2.00049C2.00049 11.7901 3.79135 9.99921 6.00049 9.99921L7.99893 9.99921C9.1035 9.99921 9.99893 9.10378 9.99893 7.99921L13.9989 7.99921C13.9989 11.3124 11.3134 13.9984 8.00039 13.9992Z"
                fill="url(#paint2_radial_148635:964)"
                fill-opacity="0.56"
            />
            <path
                d="M2 7.99853V13.9984C4.20914 13.9984 6 12.2076 6 9.99844L6 8C6 6.89543 6.89543 6 8 6V2C4.68678 2 2.00079 4.6855 2 7.99853Z"
                fill="url(#paint3_linear_148635:964)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_148635:964"
                    x1="14"
                    y1="14"
                    x2="2"
                    y2="2"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#50E6FF" />
                    <stop offset="1" stop-color="#8661C5" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_148635:964"
                    x1="3.80035"
                    y1="12.0492"
                    x2="4.59757"
                    y2="7.83586"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#50E6FF" />
                    <stop offset="1" stop-color="#50E6FF" stop-opacity="0" />
                </linearGradient>
                <radialGradient
                    id="paint2_radial_148635:964"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(4.35742 11.8563) rotate(-143.127) scale(2.14268 4.615)">
                    <stop />
                    <stop offset="0.699824" stop-opacity="0" />
                </radialGradient>
                <linearGradient
                    id="paint3_linear_148635:964"
                    x1="3.8"
                    y1="8.44916"
                    x2="7.0995"
                    y2="4.54924"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#8661C5" />
                    <stop offset="1" stop-color="#8661C5" stop-opacity="0" />
                </linearGradient>
            </defs>
        </svg>
    ),
    displayName: 'IcFluentLoopColor',
});

registerIcons({
    icons: {
        IcFluentLoopColor: <IcFluentLoopColor />,
    },
});
